<template>
  <van-search
    v-model="searchcontent"
    :placeholder="$i18n.t('member.search')"
    @search="onSearch"
  />
  <div class="flexbox chatlist">
    <div
      class="flexbox"
      v-for="(item, index) of chatContentList"
      :key="index"
      @click="setCur(item.uid, item)"
    >
      <van-swipe-cell>
        <div class="flexbox chatitem">
          <div class="avatar" v-if="item.count > 0">
            <van-badge :content="item.count" max="99">
              <img :src="imgurl + item.avatar" alt="" class="avatar" />
            </van-badge>
          </div>
          <img :src="imgurl + item.avatar" alt="" class="avatar" v-else />
          <div class="flexbox usermsg">
            <div class="flexbox msgbox">
              <div class="username">
                <i
                  class="iconfont icon-V"
                  style="color: gold"
                  v-if="item.vip == 2"
                ></i>
                <i
                  class="iconfont icon-V"
                  style="color: silver"
                  v-else-if="item.vip == 1"
                ></i>
                {{ item.nickname || item.username }}
              </div>
              <div class="chatcontent">
                <Expression :text="item.content" :singleLine="true" />
              </div>
            </div>
            <div class="flexbox onlinebox">
              <div
                class="circle"
                :class="{
                  online: item.is_online == 1,
                  offline: item.is_online == 0,
                }"
              ></div>
            </div>
          </div>
        </div>

        <template #right>
          <div class="flexbox delete" @click="deleteuser(item.uid)">
            <van-icon name="delete-o" color="#fff" size="24px" />
          </div>
        </template>
      </van-swipe-cell>
    </div>
  </div>
  <Menu></Menu>
</template>

<script>
import Expression from "../../../../components/Expression.vue";
import Menu from "../../../../components/mobile/Menu.vue";

export default {
  data() {
    return {
      searchcontent: "",
    };
  },
  components: {
    Expression,
    Menu,
  },
  methods: {
    onSearch() {},
    setCur(id,item) {
      if (item.is_service !== 1 && (!this.vip || ![1,2].includes(+this.vip))){
        this.$message.error(this.$t("tips.upmember1"));
        return;
      }

      this.$store.commit("setCur", id);
      this.$store.dispatch("wssend", {
        opt: 0,
        uid: this.$store.state.User.id,
        address: id,
        origin: true,
      });
      this.$store.commit("clearcount", id);
      this.$router.push("/m/home/chat/index");
    },
    deleteuser(address) {
      this.$store.dispatch("wssend", {
        opt: 5,
        uid: this.$store.state.User.id,
        address: address,
        origin: true,
      });
    },
  },
  computed: {
    chatContentList() {
      let reg = new RegExp(`(${this.searchcontent})`, "g");
      return this.$store.state.Chat.chatList.filter((item) => {
        // console.log(item)
        return reg.test(item.nickname || item.username);
      });
    },
    vip() {
      return this.$store.state.User.vip;
    },
  },
};
</script>

<style lang="scss" scoped>
.van-swipe-cell {
  width: 100%;
}
.chatlist {
  padding-bottom: 60px;
  .chatitem {
    padding: 11px 15px;
    flex-wrap: nowrap;
    .avatar {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      flex-shrink: 0;
    }
    .usermsg {
      height: 52px;
      flex-wrap: nowrap;
      .msgbox {
        height: 52px;
        padding: 0 10px;
        align-content: space-around;
        .username {
          width: 100%;
          max-width: 240px !important;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .chatcontent {
          width: 100%;
          max-width: 240px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .onlinebox {
        width: 50px;
        flex-shrink: 0;
        .circle {
          width: 5px;
          height: 5px;
          border-radius: 50%;
        }
        .online {
          background-color: #6f6;
        }
        .offline {
          background-color: #aaa;
        }
      }
    }
  }
}
.delete {
  background-color: #ff4a53;
  width: 74px;
  height: 74px;
}
</style>
